<template>
  <router-view />
  <PiniaColadaDevtools v-if="isPlaywright" />
</template>

<script setup lang="ts">
import { PiniaColadaDevtools } from '@pinia/colada-devtools';
import { computed } from 'vue';

const isPlaywright = computed<boolean>(
  () => import.meta.env.VITE_IS_PLAYWRIGHT === 'true',
);
</script>
